import { Action } from 'redux';
import { BffUpdateUserConsentsRequest, BffUserConsentsResponse } from '@lucky7ventures/bff-types';

export enum ConsentsActionTypes {
  GetConsents = 'GET_CONSENTS',
  GetConsentsSuccess = 'GET_CONSENTS_SUCCESS',
  GetConsentsError = 'GET_CONSENTS_ERROR',
  UpdateConsents = 'UPDATE_CONSENTS',
  UpdateConsentsSuccess = 'UPDATE_CONSENTS_SUCCESS',
  UpdateConsentsError = 'UPDATE_CONSENTS_ERROR',
  ResetConsents = 'RESET_CONSENTS',
}

export type GetConsentsAction = Action<ConsentsActionTypes.GetConsents>;
export type GetConsentsSuccessAction = Action<ConsentsActionTypes.GetConsentsSuccess> & {
  consents: BffUserConsentsResponse;
};
export type GetConsentsErrorAction = Action<ConsentsActionTypes.GetConsentsError>;
export type UpdateConsentsAction = Action<ConsentsActionTypes.UpdateConsents> & {
  payload: BffUpdateUserConsentsRequest;
};
export type UpdateConsentsSuccessAction = Action<ConsentsActionTypes.UpdateConsentsSuccess> & {
  consents: BffUserConsentsResponse;
};
export type UpdateConsentsErrorAction = Action<ConsentsActionTypes.UpdateConsentsError>;
export type ResetConsentsAction = Action<ConsentsActionTypes.ResetConsents>;

export type ConsentsActions =
  | GetConsentsAction
  | GetConsentsSuccessAction
  | GetConsentsErrorAction
  | ResetConsentsAction
  | UpdateConsentsAction
  | UpdateConsentsSuccessAction
  | UpdateConsentsErrorAction;

export const getConsents = (): GetConsentsAction => ({
  type: ConsentsActionTypes.GetConsents,
});

export const getConsentsSuccess = (
  consents: BffUserConsentsResponse,
): GetConsentsSuccessAction => ({
  type: ConsentsActionTypes.GetConsentsSuccess,
  consents,
});

export const getConsentsError = (): GetConsentsErrorAction => ({
  type: ConsentsActionTypes.GetConsentsError,
});

export const updateConsents = (payload: BffUpdateUserConsentsRequest): UpdateConsentsAction => ({
  type: ConsentsActionTypes.UpdateConsents,
  payload,
});

export const updateConsentsSuccess = (
  consents: BffUserConsentsResponse,
): UpdateConsentsSuccessAction => ({
  type: ConsentsActionTypes.UpdateConsentsSuccess,
  consents,
});

export const updateConsentsError = (): UpdateConsentsErrorAction => ({
  type: ConsentsActionTypes.UpdateConsentsError,
});

export const resetConsents = (): ResetConsentsAction => ({
  type: ConsentsActionTypes.ResetConsents,
});
